import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const SicaanIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Sicaan"
        data-name="Sicaan"
        xmlns="http://www.w3.org/2000/svg"
        // viewBox="0 0 176.82 150.01"
        viewBox="0 0 330.09 379.13"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <g>
            <path
              fill={themeColor === 'light' ? '#0e0504' : '#fff'}
              d="M242.63,253.4c-6.76,19.56-24.62,31.95-43.76,37.79c-2.79,0.85-5.61,1.58-8.45,2.18
					c-2.13,0.46-6.51,2.18-7.54-0.74c-0.35-0.99-0.13-2.33-0.13-3.34v-5.61c0-1.33-0.05-2.68,0-4.01c0.08-2.72,2.01-3.41,4.32-3.96
					c5.33-1.28,10.52-3.11,15.34-5.71c8.41-4.56,15.47-11.58,18.62-20.76c2.41-7.03,2.77-15.06,0.73-22.15
					c-2.93-10.21-11.39-16.71-21.09-20.81c-11.73-4.97-24.83-7.13-37.4-9.31c-13.49-2.32-27.13-4.36-40.25-8.4
					c-11.51-3.54-23.29-8.87-31.02-18.48c-9.1-11.27-11.03-26.8-8.2-40.7c1.76-8.66,5.86-16.7,11.86-23.18
					c6.22-6.71,14.19-11.5,22.65-14.84c9.89-3.89,20.53-5.78,31.11-6.48c11.16-0.73,22.48-0.24,33.48,1.81
					c18.33,3.42,36.41,11.93,47,27.85c5.38,8.08,8.3,17.5,9.3,27.11c0.14,1.36,0.25,2.72,0.32,4.09c0.06,1.31,0.17,2.62-0.62,3.75
					c-0.95,1.39-2.49,1.51-4.01,1.51h-10.34c-0.98,0-1.97,0.04-2.94,0c-1.21-0.06-2.34-0.49-3.06-1.51
					c-0.78-1.12-0.68-2.46-0.77-3.77c-0.37-4.98-1.4-9.93-3.23-14.58c-3.29-8.31-9.39-15.13-17.01-19.71
					c-8.31-5.01-17.98-7.48-27.57-8.47c-10.99-1.13-22.46-0.77-33.25,1.76c-8.68,2.04-17.28,5.71-23.46,12.32
					c-5.94,6.34-8.49,14.72-8.52,23.3c0.01,4.74,0.98,9.33,3.38,13.35c2.3,3.89,5.75,6.95,9.68,9.33c4.62,2.8,9.46,4.6,14.65,6.14
					c12.49,3.71,25.5,5.43,38.31,7.57c13.19,2.2,26.53,4.57,39.03,9.4c11.42,4.42,22.22,11.16,28.75,21.82
					c3.4,5.57,5.44,11.88,6.34,18.34C246.15,235.33,245.64,244.73,242.63,253.4z"
            />
          </g>
          <g>
            <path
              fill={'#da8e82'}
              d="M169.13,224.14v66.31c0,2.27-1.84,4.12-4.12,4.12H88.68c-2.27,0-4.12-1.84-4.12-4.12v-66.31
					c0-2.27,1.84-4.12,4.12-4.12h76.33C167.29,220.02,169.13,221.86,169.13,224.14z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default SicaanIcon;
